<form *ngIf='formGroup'
      [formGroup]='formGroup' class='widget'>
  <div class='form-group'>
    <pt-input-label
      *ngIf='label'
      [inputId]='inputId'
      [isRequired]='isRequired'
      [label]='label'
      style='display: contents'
    ></pt-input-label>
    <div
      [ngClass]="{'is-invalid': formGroup.invalid}"
      class='form-control form-control-sm ng-select-multiple-control'
    >

      <ng-select
        [items]="[]"
        [addTag]="true"
        [multiple]="true"
        [hideSelected]="true"
        [minTermLength]="2"
        [loading]="false"
        addTagText="{{'MESSAGE.PRESS_ENTER_SELECT' | translate}}"
        notFoundText="{{'MESSAGE.ADD_TEXT_AND_PRESS_ENTER_SELECT' | translate}}"
        typeToSearchText="{{'MESSAGE.ADD_TEXT_AND_PRESS_ENTER_SELECT' | translate}}"
        formControlName='value'>
      </ng-select>
<!--      <ng-select-->
<!--        [items]="[]"-->
<!--        [addTag]="true"-->
<!--        [multiple]="true"-->
<!--        [selectOnTab]="true"-->
<!--        [isOpen]="false"-->
<!--        [id]='inputId'-->
<!--        [readonly]='disabled'-->
<!--        typeToSearchText="{{'MESSAGE.PRESS_ENTER_SELECT' | translate}}"-->
<!--        formControlName='value'-->
<!--        appendTo="body"-->
<!--      >-->
<!--      </ng-select>-->
<!--      [placeholder]='placeholder'-->
    </div>
<!--    <small-->
<!--      [innerHTML]='help'-->
<!--      class='form-text text-muted' id='ptWFilteredSelectHelp_{{controlName}}'-->
<!--    ></small>-->
  </div>
</form>
